import React from 'react';

function Reset({ color, height, width }) {

	return (
    <svg height={ height } width={ width } viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <g fill={ color }>
        <path d="M2.502,12.333c-0.726-0.92-1.212-2.016-1.405-3.168l1.973-0.331 c0.138,0.822,0.484,1.604,1.003,2.26L2.502,12.333z"/>
        <path d="M6.834,14.903c-1.07-0.18-2.1-0.615-2.976-1.259l1.186-1.611 c0.624,0.459,1.358,0.77,2.122,0.898L6.834,14.903z"/>
        <path d="M9.165,14.903l-0.33-1.973c0.799-0.134,1.563-0.467,2.209-0.964l1.219,1.586 C11.358,14.248,10.287,14.715,9.165,14.903z"/>
        <path d="M8,1C6.127,1,4.35,1.759,3.052,3.052L0.9,0.9L0.2,7.3l6.4-0.7L4.465,4.465C5.393,3.542,6.662,3,8,3 c2.757,0,5,2.243,5,5c0,1.06-0.327,2.072-0.947,2.928l1.621,1.173C14.541,10.901,15,9.483,15,8C15,4.14,11.859,1,8,1z" fill={ color }/>
      </g>
    </svg>
	);
};

export default Reset;